import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { BasicFormInputComponent } from "../../basic/basic-form-input.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CabLabelComponent } from "../cab-label/cab-label.component";
import { NgClass } from "@angular/common";

@Component({
  selector: "app-cab-textarea",
  templateUrl: "./cab-textarea.component.html",
  styleUrls: ["./cab-textarea.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgClass,
    CabLabelComponent,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
})
export class CabTextareaComponent extends BasicFormInputComponent {
  @Input() rows = 2;
}
